export default __webpack_public_path__ + "static/IP_Vision_Pro_04-131503983776562ad6a5e67e5d30e223.webp";